import React, { useMemo } from 'react';

interface CardProps {
  value: number;
  size?: 'sm' | 'lg' | 'mobile';
}

export default function Card({ value, size = 'sm' }: CardProps) {
  const getCardLabel = (val: number) => {
    if (val === 14) return 'A';
    if (val === 13) return 'K';
    if (val === 12) return 'Q';
    if (val === 11) return 'J';
    return val.toString();
  };

  // Use useMemo to ensure consistent suit colors per card
  const suit = useMemo(() => {
    const suits = ['♥', '♦', '♣', '♠'];
    return suits[value % 4];
  }, [value]);

  const isRed = suit === '♥' || suit === '♦';
  const label = getCardLabel(value);

  const sizeClasses = size === 'lg' 
    ? 'w-24 h-36 text-2xl' 
    : size === 'mobile'
    ? 'w-16 h-24 text-sm'
    : 'w-20 h-32 text-xl';

  return (
    <div className={`${sizeClasses} rounded-lg font-bold flex flex-col items-center justify-center border-2 shadow-lg card-flip ${
      isRed
        ? 'bg-white border-red-500 text-red-600'
        : 'bg-white border-black text-black'
    }`}>
      <div className="text-sm font-semibold">{label}</div>
      <div className="text-base">{suit}</div>
    </div>
  );
}